import { Product, Variant } from "@/types/types.ts";
import {
  isVariantReducedToClear,
  isVariantPromotional,
  isAllVariantsReduced,
  isAllVariantsSave,
  isAllVariantsReducedForColour,
  isSomeVariantsReducedForColour,
  isAllVariantsSaveForColour,
  isSomeVariantsSaveForColour,
  getProductPriceMatchNonPriceEstablishedStatus,
  isVariantPriceMatchedNonPriceEstablished,
  getPriceMatchNonPriceEstablishedStatusForColour,
} from "./promotionUtils";
import { getColourGroupForVariant } from "@/utils/product/getColourGroupForVariant.ts";
import { hasColours } from "@/utils/product/hasColours.ts";

export const getSizeReductionLabelInfo = (
  product: Product,
  sizeVariant: Variant,
  {
    showPromoOnIndicators,
  }: {
    showPromoOnIndicators: boolean;
  },
  isUnavailable: boolean,
) => {
  if (isUnavailable) {
    return {
      showReduced: false,
      label: "",
    };
  }

  const isAllVariantsReducedToClear = isAllVariantsReduced(product);
  const isAllVariantsOnSave = isAllVariantsSave(product);

  const productPriceMatchNonPriceEstablishedStatus =
    getProductPriceMatchNonPriceEstablishedStatus(product);
  const isAllVariantsPriceMatchedNotPriceEstablished =
    productPriceMatchNonPriceEstablishedStatus === "all";

  if (
    isAllVariantsReducedToClear ||
    isAllVariantsOnSave ||
    isAllVariantsPriceMatchedNotPriceEstablished
  ) {
    return {
      showReduced: showPromoOnIndicators,
      label: showPromoOnIndicators
        ? isAllVariantsReducedToClear
          ? "Reduced"
          : isAllVariantsOnSave
            ? "Offer"
            : "Offer"
        : "",
    };
  }

  const isReducedToClear = isVariantReducedToClear(sizeVariant);
  const isSave = isVariantPromotional(sizeVariant);
  const isPriceMatchedNonEstablished =
    isVariantPriceMatchedNonPriceEstablished(sizeVariant);

  const reducedOrOfferLabel = isReducedToClear
    ? "Reduced"
    : isSave
      ? "Offer"
      : isPriceMatchedNonEstablished
        ? "Offer"
        : "";

  if (!hasColours(product)) {
    return {
      showReduced: isReducedToClear || isSave || isPriceMatchedNonEstablished,
      label: reducedOrOfferLabel,
    };
  }

  const variantGroup = getColourGroupForVariant(
    product.variantGroups,
    sizeVariant.id,
  );

  if (variantGroup) {
    if (isAllVariantsReducedForColour(variantGroup)) {
      return {
        showReduced: showPromoOnIndicators,
        label: showPromoOnIndicators ? reducedOrOfferLabel : "",
      };
    }

    if (isAllVariantsSaveForColour(variantGroup)) {
      return {
        showReduced: showPromoOnIndicators,
        label: showPromoOnIndicators ? reducedOrOfferLabel : "",
      };
    }

    const priceMatchNonPriceEstablishedStatus =
      getPriceMatchNonPriceEstablishedStatusForColour(variantGroup);

    if (priceMatchNonPriceEstablishedStatus === "all") {
      return {
        showReduced: showPromoOnIndicators,
        label: showPromoOnIndicators ? reducedOrOfferLabel : "",
      };
    }

    if (
      isSomeVariantsReducedForColour(variantGroup) ||
      isSomeVariantsSaveForColour(variantGroup) ||
      priceMatchNonPriceEstablishedStatus === "some"
    ) {
      return {
        showReduced: isReducedToClear || isSave || isPriceMatchedNonEstablished,
        label: reducedOrOfferLabel,
      };
    }
  }

  return { showReduced: false, label: "" };
};
